(function () {
  function eddRoot() {
    return document.querySelector('.grail-edd-block');
  }

  function eddText(name, fallback) {
    var root = eddRoot();
    var value = root && root.getAttribute(name);
    return value || fallback;
  }

  function formatEddLabel(daysFromToday, dubaiTime) {
    if (daysFromToday === 0) return eddText('data-label-today', 'Today');
    if (daysFromToday === 1) return eddText('data-label-tomorrow', 'Tomorrow');
    var date = new Date(dubaiTime);
    date.setDate(dubaiTime.getDate() + daysFromToday);
    return date.toLocaleDateString(eddText('data-date-locale', 'en-US'), { month: 'short', day: 'numeric' });
  }

  function plateSelected() {
    var plate = document.querySelector('[data-addon-toggle="plate"]');
    return !!(plate && plate.checked);
  }

  function addWorkingDays(date, workingDays) {
    var shifted = new Date(date);
    var added = 0;
    while (added < workingDays) {
      shifted.setDate(shifted.getDate() + 1);
      if (shifted.getDay() !== 0) added += 1;
    }
    return shifted;
  }

  function daysFrom(dubaiTime, target) {
    var start = new Date(dubaiTime.getFullYear(), dubaiTime.getMonth(), dubaiTime.getDate());
    var end = new Date(target.getFullYear(), target.getMonth(), target.getDate());
    return Math.round((end.getTime() - start.getTime()) / 86400000);
  }

  function formatRange(earlyDays, lateDays, dubaiTime) {
    var early = formatEddLabel(earlyDays, dubaiTime);
    var late = formatEddLabel(lateDays, dubaiTime);
    if (early === late) return early;
    return early + ' – ' + late;
  }

  function updateEDD() {
    var now = new Date();
    var utcTime = now.getTime() + now.getTimezoneOffset() * 60000;
    var dubaiTime = new Date(utcTime + 3600000 * 4);

    var day = dubaiTime.getDay();
    var hour = dubaiTime.getHours();

    var dispatchDaysToAdd = 0;
    var deliveryDaysToAdd = 0;

    if (day >= 1 && day <= 5) {
      if (hour < 16) {
        dispatchDaysToAdd = 0;
        deliveryDaysToAdd = 1;
      } else {
        dispatchDaysToAdd = 1;
        deliveryDaysToAdd = 2;
      }
    } else if (day === 6) {
      if (hour < 15) {
        dispatchDaysToAdd = 0;
        deliveryDaysToAdd = 1;
      } else {
        dispatchDaysToAdd = 2;
        deliveryDaysToAdd = 2;
      }
    } else if (day === 0) {
      dispatchDaysToAdd = 1;
      deliveryDaysToAdd = 1;
    }

    var dispatchLabel = formatEddLabel(dispatchDaysToAdd, dubaiTime);
    var deliveryLabel = formatEddLabel(deliveryDaysToAdd, dubaiTime);

    if (plateSelected()) {
      var baseDispatch = new Date(dubaiTime);
      baseDispatch.setDate(dubaiTime.getDate() + dispatchDaysToAdd);
      var dispatchEarly = addWorkingDays(baseDispatch, 1);
      var dispatchLate = addWorkingDays(baseDispatch, 2);
      var transitDays = deliveryDaysToAdd - dispatchDaysToAdd;

      function afterTransit(date) {
        var shifted = new Date(date);
        shifted.setDate(shifted.getDate() + transitDays);
        return shifted;
      }

      dispatchLabel = formatRange(
        daysFrom(dubaiTime, dispatchEarly),
        daysFrom(dubaiTime, dispatchLate),
        dubaiTime
      );
      deliveryLabel = formatRange(
        daysFrom(dubaiTime, afterTransit(dispatchEarly)),
        daysFrom(dubaiTime, afterTransit(dispatchLate)),
        dubaiTime
      );
    }

    var dispatchEl = document.getElementById('edd-date-dispatch');
    if (dispatchEl) dispatchEl.textContent = dispatchLabel;

    var deliveryEl = document.getElementById('edd-date-delivery');
    if (deliveryEl) deliveryEl.textContent = deliveryLabel;

    var topDeliveryEl = document.getElementById('edd-delivery-top');
    if (topDeliveryEl) topDeliveryEl.textContent = deliveryLabel;

    var cutoff = new Date(dubaiTime);
    if (day === 0) {
      cutoff.setDate(cutoff.getDate() + 1);
      cutoff.setHours(16, 0, 0, 0);
    } else if (day === 6) {
      if (hour < 15) {
        cutoff.setHours(15, 0, 0, 0);
      } else {
        cutoff.setDate(cutoff.getDate() + 2);
        cutoff.setHours(16, 0, 0, 0);
      }
    } else if (day === 5) {
      if (hour < 16) {
        cutoff.setHours(16, 0, 0, 0);
      } else {
        cutoff.setDate(cutoff.getDate() + 1);
        cutoff.setHours(15, 0, 0, 0);
      }
    } else if (hour < 16) {
      cutoff.setHours(16, 0, 0, 0);
    } else {
      cutoff.setDate(cutoff.getDate() + 1);
      cutoff.setHours(16, 0, 0, 0);
    }

    var diff = cutoff - dubaiTime;
    var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var s = Math.floor((diff % (1000 * 60)) / 1000);

    var countdownEl = document.getElementById('edd-countdown');
    if (countdownEl) {
      countdownEl.textContent =
        h + eddText('data-unit-h', 'H') + ' ' + m + eddText('data-unit-m', 'M') + ' ' + s + eddText('data-unit-s', 'S');
    }
  }

  function init() {
    window.GrailEdd = { refresh: updateEDD };
    if (!document.querySelector('.grail-edd-block')) return;
    updateEDD();
    window.setInterval(updateEDD, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
